const category = [{
  "categoryId": "1001",
  "categoryName": "服饰/鞋靴/箱包",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1002",
    "categoryName": "服饰",
    "categoryPid": "1001",
    "children": [{
      "categoryId": "1003",
      "categoryName": "男女装",
      "categoryPid": "1002"
    }, {
      "categoryId": "1004",
      "categoryName": "童装",
      "categoryPid": "1002"
    }, {
      "categoryId": "1005",
      "categoryName": "内衣/寝居服饰",
      "categoryPid": "1002"
    }, {
      "categoryId": "1006",
      "categoryName": "配件",
      "categoryPid": "1002"
    }]
  }, {
    "categoryId": "1007",
    "categoryName": "鞋靴",
    "categoryPid": "1001",
    "children": [{
      "categoryId": "1008",
      "categoryName": "成人鞋靴",
      "categoryPid": "1007"
    }, {
      "categoryId": "1009",
      "categoryName": "童鞋",
      "categoryPid": "1007"
    }]
  }, {
    "categoryId": "1010",
    "categoryName": "箱包",
    "categoryPid": "1001",
    "children": [{
      "categoryId": "1011",
      "categoryName": "时尚箱包",
      "categoryPid": "1010"
    }, {
      "categoryId": "1012",
      "categoryName": "功能箱包",
      "categoryPid": "1010"
    }]
  }]
}, {
  "categoryId": "1013",
  "categoryName": "珠宝/钟表",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1014",
    "categoryName": "首饰/配饰",
    "categoryPid": "1013",
    "children": [{
      "categoryId": "1015",
      "categoryName": "珠宝/贵金属",
      "categoryPid": "1014"
    }, {
      "categoryId": "1016",
      "categoryName": "木手件/把件",
      "categoryPid": "1014"
    }, {
      "categoryId": "1017",
      "categoryName": "首饰",
      "categoryPid": "1014"
    }, {
      "categoryId": "1018",
      "categoryName": "时尚饰品",
      "categoryPid": "1014"
    }, {
      "categoryId": "1309",
      "categoryName": "黄金",
      "categoryPid": "1014"
    }, {
      "categoryId": "1310",
      "categoryName": "铂金",
      "categoryPid": "1014"
    }, {
      "categoryId": "1311",
      "categoryName": "K金",
      "categoryPid": "1014"
    }, {
      "categoryId": "1312",
      "categoryName": "银饰",
      "categoryPid": "1014"
    }]
  }, {
    "categoryId": "1019",
    "categoryName": "钟表",
    "categoryPid": "1013",
    "children": [{
      "categoryId": "1020",
      "categoryName": "时尚手表",
      "categoryPid": "1019"
    }, {
      "categoryId": "1021",
      "categoryName": "功能钟表",
      "categoryPid": "1019"
    }]
  }, {
    "categoryId": "1307",
    "categoryName": "玉石",
    "categoryPid": "1013",
    "children": [{
      "categoryId": "1313",
      "categoryName": "翡翠原石",
      "categoryPid": "1307"
    }, {
      "categoryId": "1314",
      "categoryName": "翡翠成品",
      "categoryPid": "1307"
    }, {
      "categoryId": "1315",
      "categoryName": "和田玉",
      "categoryPid": "1307"
    }, {
      "categoryId": "1316",
      "categoryName": "玛瑙",
      "categoryPid": "1307"
    }, {
      "categoryId": "1317",
      "categoryName": "其他玉石",
      "categoryPid": "1307"
    }]
  }, {
    "categoryId": "1308",
    "categoryName": "宝石",
    "categoryPid": "1013",
    "children": [{
      "categoryId": "1318",
      "categoryName": "彩色宝石",
      "categoryPid": "1308"
    }, {
      "categoryId": "1319",
      "categoryName": "珍珠",
      "categoryPid": "1308"
    }, {
      "categoryId": "1320",
      "categoryName": "其他宝石",
      "categoryPid": "1308"
    }]
  }]
}, {
  "categoryId": "1022",
  "categoryName": "运动户外",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1023",
    "categoryName": "运动户外鞋服",
    "categoryPid": "1022",
    "children": [{
      "categoryId": "1024",
      "categoryName": "运动鞋服",
      "categoryPid": "1023"
    }, {
      "categoryId": "1025",
      "categoryName": "户外鞋服",
      "categoryPid": "1023"
    }]
  }, {
    "categoryId": "1026",
    "categoryName": "运动用品",
    "categoryPid": "1022",
    "children": [{
      "categoryId": "1027",
      "categoryName": "健身训练",
      "categoryPid": "1026"
    }, {
      "categoryId": "1028",
      "categoryName": "体育用品",
      "categoryPid": "1026"
    }]
  }, {
    "categoryId": "1029",
    "categoryName": "户外用具",
    "categoryPid": "1022",
    "children": [{
      "categoryId": "1030",
      "categoryName": "户外装备",
      "categoryPid": "1029"
    }, {
      "categoryId": "1031",
      "categoryName": "骑行运动",
      "categoryPid": "1029"
    }, {
      "categoryId": "1032",
      "categoryName": "垂钓用品",
      "categoryPid": "1029"
    }, {
      "categoryId": "1033",
      "categoryName": "游泳用品",
      "categoryPid": "1029"
    }]
  }]
}, {
  "categoryId": "1034",
  "categoryName": "孕婴/乐器/玩具",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1035",
    "categoryName": "寝居用品",
    "categoryPid": "1034",
    "children": [{
      "categoryId": "1036",
      "categoryName": "孕产寝居",
      "categoryPid": "1035"
    }, {
      "categoryId": "1037",
      "categoryName": "婴童寝居",
      "categoryPid": "1035"
    }]
  }, {
    "categoryId": "1038",
    "categoryName": "婴童用品",
    "categoryPid": "1034",
    "children": [{
      "categoryId": "1039",
      "categoryName": "喂养用品",
      "categoryPid": "1038"
    }, {
      "categoryId": "1040",
      "categoryName": "婴幼洗护",
      "categoryPid": "1038"
    }]
  }, {
    "categoryId": "1041",
    "categoryName": "奶粉/辅食",
    "categoryPid": "1034",
    "children": [{
      "categoryId": "1042",
      "categoryName": "奶粉",
      "categoryPid": "1041"
    }, {
      "categoryId": "1043",
      "categoryName": "辅食",
      "categoryPid": "1041"
    }]
  }, {
    "categoryId": "1044",
    "categoryName": "童车/手推车/童床/安全座椅",
    "categoryPid": "1034",
    "children": [{
      "categoryId": "1045",
      "categoryName": "童车/手推车",
      "categoryPid": "1044"
    }, {
      "categoryId": "1046",
      "categoryName": "童床",
      "categoryPid": "1044"
    }, {
      "categoryId": "1047",
      "categoryName": "安全座椅",
      "categoryPid": "1044"
    }]
  }, {
    "categoryId": "1048",
    "categoryName": "尿裤湿巾",
    "categoryPid": "1034",
    "children": [{
      "categoryId": "1049",
      "categoryName": "尿裤湿巾",
      "categoryPid": "1048"
    }, {
      "categoryId": "1050",
      "categoryName": "成人尿裤",
      "categoryPid": "1048"
    }]
  }, {
    "categoryId": "1051",
    "categoryName": "乐器",
    "categoryPid": "1034",
    "children": [{
      "categoryId": "1052",
      "categoryName": "乐器",
      "categoryPid": "1051"
    }]
  }, {
    "categoryId": "1053",
    "categoryName": "玩具",
    "categoryPid": "1034",
    "children": [{
      "categoryId": "1054",
      "categoryName": "玩具",
      "categoryPid": "1053"
    }]
  }]
}, {
  "categoryId": "1055",
  "categoryName": "美妆/个护清洁",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1056",
    "categoryName": "美妆护肤",
    "categoryPid": "1055",
    "children": [{
      "categoryId": "1057",
      "categoryName": "护肤",
      "categoryPid": "1056"
    }, {
      "categoryId": "1058",
      "categoryName": "香水",
      "categoryPid": "1056"
    }, {
      "categoryId": "1059",
      "categoryName": "彩妆",
      "categoryPid": "1056"
    }]
  }, {
    "categoryId": "1060",
    "categoryName": "个人清洁",
    "categoryPid": "1055",
    "children": [{
      "categoryId": "1061",
      "categoryName": "美发护发",
      "categoryPid": "1060"
    }, {
      "categoryId": "1062",
      "categoryName": "口腔护理",
      "categoryPid": "1060"
    }, {
      "categoryId": "1063",
      "categoryName": "身体护理",
      "categoryPid": "1060"
    }, {
      "categoryId": "1064",
      "categoryName": "纸品湿巾",
      "categoryPid": "1060"
    }]
  }]
}, {
  "categoryId": "1065",
  "categoryName": "手机/数码/电脑办公",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1066",
    "categoryName": "手机/配件",
    "categoryPid": "1065",
    "children": [{
      "categoryId": "1067",
      "categoryName": "手机",
      "categoryPid": "1066"
    }, {
      "categoryId": "1068",
      "categoryName": "手机配件",
      "categoryPid": "1066"
    }]
  }, {
    "categoryId": "1069",
    "categoryName": "数码",
    "categoryPid": "1065",
    "children": [{
      "categoryId": "1070",
      "categoryName": "摄影摄像",
      "categoryPid": "1069"
    }, {
      "categoryId": "1071",
      "categoryName": "数码配件",
      "categoryPid": "1069"
    }, {
      "categoryId": "1072",
      "categoryName": "影音娱乐",
      "categoryPid": "1069"
    }, {
      "categoryId": "1073",
      "categoryName": "智能设备",
      "categoryPid": "1069"
    }, {
      "categoryId": "1074",
      "categoryName": "电子教育",
      "categoryPid": "1069"
    }]
  }, {
    "categoryId": "1075",
    "categoryName": "电脑/外设",
    "categoryPid": "1065",
    "children": [{
      "categoryId": "1076",
      "categoryName": "电脑整机",
      "categoryPid": "1075"
    }, {
      "categoryId": "1077",
      "categoryName": "电脑配件",
      "categoryPid": "1075"
    }, {
      "categoryId": "1078",
      "categoryName": "外设产品",
      "categoryPid": "1075"
    }, {
      "categoryId": "1079",
      "categoryName": "游戏设备",
      "categoryPid": "1075"
    }, {
      "categoryId": "1080",
      "categoryName": "网络产品",
      "categoryPid": "1075"
    }]
  }, {
    "categoryId": "1081",
    "categoryName": "办公设备",
    "categoryPid": "1065",
    "children": [{
      "categoryId": "1082",
      "categoryName": "办公设备",
      "categoryPid": "1081"
    }, {
      "categoryId": "1083",
      "categoryName": "耗材",
      "categoryPid": "1081"
    }]
  }]
}, {
  "categoryId": "1084",
  "categoryName": "家用电器",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1085",
    "categoryName": "大家电",
    "categoryPid": "1084",
    "children": [{
      "categoryId": "1086",
      "categoryName": "电视机",
      "categoryPid": "1085"
    }, {
      "categoryId": "1087",
      "categoryName": "冰箱",
      "categoryPid": "1085"
    }, {
      "categoryId": "1088",
      "categoryName": "洗衣机",
      "categoryPid": "1085"
    }, {
      "categoryId": "1089",
      "categoryName": "空调",
      "categoryPid": "1085"
    }]
  }, {
    "categoryId": "1090",
    "categoryName": "厨卫电器",
    "categoryPid": "1084",
    "children": [{
      "categoryId": "1091",
      "categoryName": "厨卫大电",
      "categoryPid": "1090"
    }, {
      "categoryId": "1092",
      "categoryName": "热水器",
      "categoryPid": "1090"
    }, {
      "categoryId": "1093",
      "categoryName": "净水饮水",
      "categoryPid": "1090"
    }]
  }, {
    "categoryId": "1094",
    "categoryName": "厨房小电",
    "categoryPid": "1084",
    "children": [{
      "categoryId": "1095",
      "categoryName": "西式厨电",
      "categoryPid": "1094"
    }, {
      "categoryId": "1096",
      "categoryName": "创意厨电",
      "categoryPid": "1094"
    }, {
      "categoryId": "1097",
      "categoryName": "中式厨电",
      "categoryPid": "1094"
    }]
  }, {
    "categoryId": "1098",
    "categoryName": "生活电器",
    "categoryPid": "1084",
    "children": [{
      "categoryId": "1099",
      "categoryName": "取暖电器",
      "categoryPid": "1098"
    }, {
      "categoryId": "1100",
      "categoryName": "净化吸尘",
      "categoryPid": "1098"
    }, {
      "categoryId": "1101",
      "categoryName": "风扇",
      "categoryPid": "1098"
    }, {
      "categoryId": "1102",
      "categoryName": "潮流生活小家电",
      "categoryPid": "1098"
    }]
  }, {
    "categoryId": "1103",
    "categoryName": "个人健康",
    "categoryPid": "1084",
    "children": [{
      "categoryId": "1104",
      "categoryName": "个人护理",
      "categoryPid": "1103"
    }, {
      "categoryId": "1105",
      "categoryName": "美容美发",
      "categoryPid": "1103"
    }, {
      "categoryId": "1106",
      "categoryName": "健康保健",
      "categoryPid": "1103"
    }]
  }]
}, {
  "categoryId": "1107",
  "categoryName": "家居生活",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1108",
    "categoryName": "家具",
    "categoryPid": "1107",
    "children": [{
      "categoryId": "1109",
      "categoryName": "家庭家具",
      "categoryPid": "1108"
    }, {
      "categoryId": "1110",
      "categoryName": "儿童家具",
      "categoryPid": "1108"
    }, {
      "categoryId": "1111",
      "categoryName": "办公家具",
      "categoryPid": "1108"
    }, {
      "categoryId": "1112",
      "categoryName": "定制家具",
      "categoryPid": "1108"
    }]
  }, {
    "categoryId": "1113",
    "categoryName": "家装建材",
    "categoryPid": "1107",
    "children": [{
      "categoryId": "1114",
      "categoryName": "厨房卫浴",
      "categoryPid": "1113"
    }, {
      "categoryId": "1115",
      "categoryName": "灯饰照明",
      "categoryPid": "1113"
    }, {
      "categoryId": "1116",
      "categoryName": "装修主材",
      "categoryPid": "1113"
    }, {
      "categoryId": "1324",
      "categoryName": "五金配件",
      "categoryPid": "1113"
    }]
  }, {
    "categoryId": "1117",
    "categoryName": "家纺",
    "categoryPid": "1107",
    "children": [{
      "categoryId": "1118",
      "categoryName": "床上用品",
      "categoryPid": "1117"
    }, {
      "categoryId": "1119",
      "categoryName": "凉席蚊帐",
      "categoryPid": "1117"
    }, {
      "categoryId": "1120",
      "categoryName": "毛巾浴巾",
      "categoryPid": "1117"
    }, {
      "categoryId": "1121",
      "categoryName": "床垫",
      "categoryPid": "1117"
    }, {
      "categoryId": "1122",
      "categoryName": "地毯地垫",
      "categoryPid": "1117"
    }, {
      "categoryId": "1123",
      "categoryName": "窗帘桌布",
      "categoryPid": "1117"
    }]
  }, {
    "categoryId": "1124",
    "categoryName": "居家日用",
    "categoryPid": "1107",
    "children": [{
      "categoryId": "1125",
      "categoryName": "生活日用",
      "categoryPid": "1124"
    }, {
      "categoryId": "1126",
      "categoryName": "文化用具",
      "categoryPid": "1124"
    }, {
      "categoryId": "1127",
      "categoryName": "家装软饰",
      "categoryPid": "1124"
    }, {
      "categoryId": "1128",
      "categoryName": "收纳用品",
      "categoryPid": "1124"
    }, {
      "categoryId": "1129",
      "categoryName": "净化除味",
      "categoryPid": "1124"
    }, {
      "categoryId": "1130",
      "categoryName": "衣物清洁",
      "categoryPid": "1124"
    }, {
      "categoryId": "1131",
      "categoryName": "家庭清洁",
      "categoryPid": "1124"
    }, {
      "categoryId": "1132",
      "categoryName": "清洁工具",
      "categoryPid": "1124"
    }, {
      "categoryId": "1133",
      "categoryName": "殡葬用品",
      "categoryPid": "1124"
    }]
  }, {
    "categoryId": "1134",
    "categoryName": "厨具",
    "categoryPid": "1107",
    "children": [{
      "categoryId": "1135",
      "categoryName": "烹饪锅具",
      "categoryPid": "1134"
    }, {
      "categoryId": "1136",
      "categoryName": "水具酒具",
      "categoryPid": "1134"
    }, {
      "categoryId": "1137",
      "categoryName": "茶具咖啡具",
      "categoryPid": "1134"
    }, {
      "categoryId": "1138",
      "categoryName": "餐具",
      "categoryPid": "1134"
    }, {
      "categoryId": "1139",
      "categoryName": "刀剪菜板",
      "categoryPid": "1134"
    }, {
      "categoryId": "1140",
      "categoryName": "酒店用品",
      "categoryPid": "1134"
    }, {
      "categoryId": "1141",
      "categoryName": "厨房配件",
      "categoryPid": "1134"
    }]
  }, {
    "categoryId": "1142",
    "categoryName": "宠物/宠物用品",
    "categoryPid": "1107",
    "children": [{
      "categoryId": "1143",
      "categoryName": "宠物主粮",
      "categoryPid": "1142"
    }, {
      "categoryId": "1144",
      "categoryName": "宠物零食",
      "categoryPid": "1142"
    }, {
      "categoryId": "1145",
      "categoryName": "宠物日用及玩具/出行装备/洗护美容用具",
      "categoryPid": "1142"
    }, {
      "categoryId": "1146",
      "categoryName": "宠物药品",
      "categoryPid": "1142"
    }, {
      "categoryId": "1147",
      "categoryName": "宠物活体",
      "categoryPid": "1142"
    }]
  }]
}, {
  "categoryId": "1148",
  "categoryName": "鲜花绿植/农资",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1149",
    "categoryName": "鲜花绿植",
    "categoryPid": "1148",
    "children": [{
      "categoryId": "1150",
      "categoryName": "鲜花",
      "categoryPid": "1149"
    }, {
      "categoryId": "1151",
      "categoryName": "花卉绿植",
      "categoryPid": "1149"
    }, {
      "categoryId": "1152",
      "categoryName": "园艺工具",
      "categoryPid": "1149"
    }, {
      "categoryId": "1153",
      "categoryName": "树苗/绿化植物",
      "categoryPid": "1149"
    }]
  }, {
    "categoryId": "1154",
    "categoryName": "农用物资",
    "categoryPid": "1148",
    "children": [{
      "categoryId": "1155",
      "categoryName": "种子",
      "categoryPid": "1154"
    }, {
      "categoryId": "1156",
      "categoryName": "农药",
      "categoryPid": "1154"
    }, {
      "categoryId": "1157",
      "categoryName": "肥料",
      "categoryPid": "1154"
    }, {
      "categoryId": "1158",
      "categoryName": "农机农具",
      "categoryPid": "1154"
    }]
  }, {
    "categoryId": "1159",
    "categoryName": "畜牧养殖",
    "categoryPid": "1148",
    "children": [{
      "categoryId": "1160",
      "categoryName": "兽药",
      "categoryPid": "1159"
    }, {
      "categoryId": "1161",
      "categoryName": "养殖器具",
      "categoryPid": "1159"
    }, {
      "categoryId": "1162",
      "categoryName": "动物种苗",
      "categoryPid": "1159"
    }]
  }]
}, {
  "categoryId": "1163",
  "categoryName": "食品",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1164",
    "categoryName": "休闲食品",
    "categoryPid": "1163",
    "children": [{
      "categoryId": "1165",
      "categoryName": "休闲零食",
      "categoryPid": "1164"
    }, {
      "categoryId": "1166",
      "categoryName": "坚果炒货",
      "categoryPid": "1164"
    }, {
      "categoryId": "1167",
      "categoryName": "肉干肉脯",
      "categoryPid": "1164"
    }, {
      "categoryId": "1168",
      "categoryName": "糖果/巧克力",
      "categoryPid": "1164"
    }, {
      "categoryId": "1169",
      "categoryName": "饼干蛋糕",
      "categoryPid": "1164"
    }, {
      "categoryId": "1170",
      "categoryName": "蜜饯果干",
      "categoryPid": "1164"
    }]
  }, {
    "categoryId": "1171",
    "categoryName": "粮油调味速食",
    "categoryPid": "1163",
    "children": [{
      "categoryId": "1172",
      "categoryName": "米面杂粮",
      "categoryPid": "1171"
    }, {
      "categoryId": "1173",
      "categoryName": "食用油",
      "categoryPid": "1171"
    }, {
      "categoryId": "1174",
      "categoryName": "调味品",
      "categoryPid": "1171"
    }, {
      "categoryId": "1175",
      "categoryName": "南北干货",
      "categoryPid": "1171"
    }, {
      "categoryId": "1176",
      "categoryName": "方便食品",
      "categoryPid": "1171"
    }]
  }, {
    "categoryId": "1177",
    "categoryName": "茶饮冲调",
    "categoryPid": "1163",
    "children": [{
      "categoryId": "1178",
      "categoryName": "茗茶",
      "categoryPid": "1177"
    }, {
      "categoryId": "1179",
      "categoryName": "饮料",
      "categoryPid": "1177"
    }, {
      "categoryId": "1180",
      "categoryName": "冲饮谷物",
      "categoryPid": "1177"
    }]
  }, {
    "categoryId": "1181",
    "categoryName": "酒类",
    "categoryPid": "1163",
    "children": [{
      "categoryId": "1182",
      "categoryName": "白酒",
      "categoryPid": "1181"
    }, {
      "categoryId": "1183",
      "categoryName": "葡萄酒",
      "categoryPid": "1181"
    }, {
      "categoryId": "1184",
      "categoryName": "啤酒",
      "categoryPid": "1181"
    }, {
      "categoryId": "1185",
      "categoryName": "黄酒",
      "categoryPid": "1181"
    }, {
      "categoryId": "1186",
      "categoryName": "洋酒",
      "categoryPid": "1181"
    }]
  }, {
    "categoryId": "1187",
    "categoryName": "生鲜",
    "categoryPid": "1163",
    "children": [{
      "categoryId": "1188",
      "categoryName": "冷饮冻食",
      "categoryPid": "1187"
    }, {
      "categoryId": "1189",
      "categoryName": "生鲜蔬果",
      "categoryPid": "1187"
    }, {
      "categoryId": "1190",
      "categoryName": "鲜活水产品",
      "categoryPid": "1187"
    }, {
      "categoryId": "1191",
      "categoryName": "生鲜蛋产品",
      "categoryPid": "1187"
    }, {
      "categoryId": "1192",
      "categoryName": "生鲜肉制品",
      "categoryPid": "1187"
    }]
  }, {
    "categoryId": "1322",
    "categoryName": "营养补充剂",
    "categoryPid": "1163",
    "children": [{
      "categoryId": "1325",
      "categoryName": "营养补充剂",
      "categoryPid": "1322"
    }]
  }]
}, {
  "categoryId": "1193",
  "categoryName": "汽车用品/助力车",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1194",
    "categoryName": "汽车用品",
    "categoryPid": "1193",
    "children": [{
      "categoryId": "1195",
      "categoryName": "维修保养",
      "categoryPid": "1194"
    }, {
      "categoryId": "1196",
      "categoryName": "汽车装饰",
      "categoryPid": "1194"
    }, {
      "categoryId": "1197",
      "categoryName": "车载电器",
      "categoryPid": "1194"
    }, {
      "categoryId": "1198",
      "categoryName": "美容清洗",
      "categoryPid": "1194"
    }, {
      "categoryId": "1199",
      "categoryName": "安全自驾",
      "categoryPid": "1194"
    }]
  }, {
    "categoryId": "1200",
    "categoryName": "助力车",
    "categoryPid": "1193",
    "children": [{
      "categoryId": "1201",
      "categoryName": "电动自行车",
      "categoryPid": "1200"
    }, {
      "categoryId": "1202",
      "categoryName": "平衡车/滑板车",
      "categoryPid": "1200"
    }, {
      "categoryId": "1203",
      "categoryName": "摩托车",
      "categoryPid": "1200"
    }, {
      "categoryId": "1204",
      "categoryName": "老年代步车",
      "categoryPid": "1200"
    }, {
      "categoryId": "1205",
      "categoryName": "助力车配件",
      "categoryPid": "1200"
    }]
  }]
}, {
  "categoryId": "1206",
  "categoryName": "房产/汽车",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1207",
    "categoryName": "房产",
    "categoryPid": "1206",
    "children": [{
      "categoryId": "1208",
      "categoryName": "住宅用途房产",
      "categoryPid": "1207"
    }, {
      "categoryId": "1209",
      "categoryName": "商业房产",
      "categoryPid": "1207"
    }]
  }, {
    "categoryId": "1210",
    "categoryName": "汽车",
    "categoryPid": "1206",
    "children": [{
      "categoryId": "1211",
      "categoryName": "家庭用车",
      "categoryPid": "1210"
    }, {
      "categoryId": "1212",
      "categoryName": "工业用车",
      "categoryPid": "1210"
    }, {
      "categoryId": "1213",
      "categoryName": "特种车辆",
      "categoryPid": "1210"
    }]
  }]
}, {
  "categoryId": "1214",
  "categoryName": "医用保健",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1215",
    "categoryName": "医疗药品",
    "categoryPid": "1214",
    "children": [{
      "categoryId": "1216",
      "categoryName": "中药材",
      "categoryPid": "1215"
    }, {
      "categoryId": "1217",
      "categoryName": "西药制剂",
      "categoryPid": "1215"
    }, {
      "categoryId": "1218",
      "categoryName": "医用器械",
      "categoryPid": "1215"
    }]
  }, {
    "categoryId": "1219",
    "categoryName": "健康保健",
    "categoryPid": "1214",
    "children": [{
      "categoryId": "1220",
      "categoryName": "营养保健",
      "categoryPid": "1219"
    }, {
      "categoryId": "1221",
      "categoryName": "营养成分",
      "categoryPid": "1219"
    }, {
      "categoryId": "1222",
      "categoryName": "滋补养生",
      "categoryPid": "1219"
    }, {
      "categoryId": "1223",
      "categoryName": "计生情趣",
      "categoryPid": "1219"
    }, {
      "categoryId": "1224",
      "categoryName": "保健器械",
      "categoryPid": "1219"
    }, {
      "categoryId": "1225",
      "categoryName": "护理护具",
      "categoryPid": "1219"
    }, {
      "categoryId": "1226",
      "categoryName": "功能眼镜/隐形眼镜",
      "categoryPid": "1219"
    }]
  }]
}, {
  "categoryId": "1227",
  "categoryName": "图书/文娱/电子书/邮币/文玩古董",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1228",
    "categoryName": "图书/期刊",
    "categoryPid": "1227",
    "children": [{
      "categoryId": "1229",
      "categoryName": "图书",
      "categoryPid": "1228"
    }, {
      "categoryId": "1230",
      "categoryName": "杂志报刊",
      "categoryPid": "1228"
    }]
  }, {
    "categoryId": "1231",
    "categoryName": "文娱",
    "categoryPid": "1227",
    "children": [{
      "categoryId": "1232",
      "categoryName": "音乐",
      "categoryPid": "1231"
    }, {
      "categoryId": "1233",
      "categoryName": "影视",
      "categoryPid": "1231"
    }, {
      "categoryId": "1234",
      "categoryName": "教育音像",
      "categoryPid": "1231"
    }, {
      "categoryId": "1235",
      "categoryName": "游戏",
      "categoryPid": "1231"
    }, {
      "categoryId": "1236",
      "categoryName": "影视/动漫周边",
      "categoryPid": "1231"
    }]
  }, {
    "categoryId": "1237",
    "categoryName": "电子书",
    "categoryPid": "1227",
    "children": [{
      "categoryId": "1238",
      "categoryName": "电子书",
      "categoryPid": "1237"
    }]
  }, {
    "categoryId": "1239",
    "categoryName": "邮币/文玩古董",
    "categoryPid": "1227",
    "children": [{
      "categoryId": "1240",
      "categoryName": "邮票/邮资封片/磁卡/票证",
      "categoryPid": "1239"
    }, {
      "categoryId": "1241",
      "categoryName": "钱币",
      "categoryPid": "1239"
    }, {
      "categoryId": "1242",
      "categoryName": "礼品册",
      "categoryPid": "1239"
    }, {
      "categoryId": "1243",
      "categoryName": "文玩古董",
      "categoryPid": "1239"
    }]
  }]
}, {
  "categoryId": "1244",
  "categoryName": "工业品",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1245",
    "categoryName": "工具/劳动防护",
    "categoryPid": "1244",
    "children": [{
      "categoryId": "1246",
      "categoryName": "工具",
      "categoryPid": "1245"
    }, {
      "categoryId": "1247",
      "categoryName": "个人防护",
      "categoryPid": "1245"
    }, {
      "categoryId": "1248",
      "categoryName": "安防用品",
      "categoryPid": "1245"
    }, {
      "categoryId": "1249",
      "categoryName": "标识",
      "categoryPid": "1245"
    }]
  }, {
    "categoryId": "1250",
    "categoryName": "工业材料",
    "categoryPid": "1244",
    "children": [{
      "categoryId": "1251",
      "categoryName": "建筑材料",
      "categoryPid": "1250"
    }, {
      "categoryId": "1252",
      "categoryName": "工业原材料",
      "categoryPid": "1250"
    }]
  }, {
    "categoryId": "1253",
    "categoryName": "工控仪表",
    "categoryPid": "1244",
    "children": [{
      "categoryId": "1254",
      "categoryName": "线缆",
      "categoryPid": "1253"
    }, {
      "categoryId": "1255",
      "categoryName": "工控配电",
      "categoryPid": "1253"
    }, {
      "categoryId": "1256",
      "categoryName": "仪器仪表",
      "categoryPid": "1253"
    }]
  }, {
    "categoryId": "1257",
    "categoryName": "照明焊接",
    "categoryPid": "1244",
    "children": [{
      "categoryId": "1258",
      "categoryName": "工业照明",
      "categoryPid": "1257"
    }, {
      "categoryId": "1259",
      "categoryName": "流体相关",
      "categoryPid": "1257"
    }, {
      "categoryId": "1260",
      "categoryName": "焊接用品",
      "categoryPid": "1257"
    }]
  }, {
    "categoryId": "1261",
    "categoryName": "工业机械",
    "categoryPid": "1244",
    "children": [{
      "categoryId": "1262",
      "categoryName": "机械设备",
      "categoryPid": "1261"
    }, {
      "categoryId": "1263",
      "categoryName": "机械配件",
      "categoryPid": "1261"
    }]
  }, {
    "categoryId": "1264",
    "categoryName": "仓储包装",
    "categoryPid": "1244",
    "children": [{
      "categoryId": "1265",
      "categoryName": "包装",
      "categoryPid": "1264"
    }, {
      "categoryId": "1266",
      "categoryName": "搬运存储",
      "categoryPid": "1264"
    }]
  }, {
    "categoryId": "1267",
    "categoryName": "化学制剂",
    "categoryPid": "1244",
    "children": [{
      "categoryId": "1268",
      "categoryName": "工业清洁用品",
      "categoryPid": "1267"
    }, {
      "categoryId": "1269",
      "categoryName": "化学品",
      "categoryPid": "1267"
    }]
  }]
}, {
  "categoryId": "1270",
  "categoryName": "虚拟/服务",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1271",
    "categoryName": "虚拟卡/会员/游戏",
    "categoryPid": "1270",
    "children": [{
      "categoryId": "1272",
      "categoryName": "电话卡/上网卡",
      "categoryPid": "1271"
    }, {
      "categoryId": "1273",
      "categoryName": "在线影视会员/音乐会员",
      "categoryPid": "1271"
    }, {
      "categoryId": "1274",
      "categoryName": "代金卡/券",
      "categoryPid": "1271"
    }, {
      "categoryId": "1275",
      "categoryName": "游戏点卡/游戏充值/QQ充值",
      "categoryPid": "1271"
    }, {
      "categoryId": "1276",
      "categoryName": "游戏代练",
      "categoryPid": "1271"
    }]
  }, {
    "categoryId": "1277",
    "categoryName": "生活服务",
    "categoryPid": "1270",
    "children": [{
      "categoryId": "1278",
      "categoryName": "安装维修",
      "categoryPid": "1277"
    }, {
      "categoryId": "1279",
      "categoryName": "装修设计",
      "categoryPid": "1277"
    }, {
      "categoryId": "1280",
      "categoryName": "家政保洁",
      "categoryPid": "1277"
    }, {
      "categoryId": "1281",
      "categoryName": "清洗服务",
      "categoryPid": "1277"
    }, {
      "categoryId": "1282",
      "categoryName": "健康美容服务",
      "categoryPid": "1277"
    }, {
      "categoryId": "1283",
      "categoryName": "休闲服务",
      "categoryPid": "1277"
    }, {
      "categoryId": "1284",
      "categoryName": "摄影/婚庆服务",
      "categoryPid": "1277"
    }, {
      "categoryId": "1285",
      "categoryName": "母婴服务",
      "categoryPid": "1277"
    }, {
      "categoryId": "1286",
      "categoryName": "体育服务",
      "categoryPid": "1277"
    }, {
      "categoryId": "1287",
      "categoryName": "宠物服务",
      "categoryPid": "1277"
    }, {
      "categoryId": "1288",
      "categoryName": "便民服务",
      "categoryPid": "1277"
    }, {
      "categoryId": "1289",
      "categoryName": "汽车服务",
      "categoryPid": "1277"
    }, {
      "categoryId": "1290",
      "categoryName": "演出票务",
      "categoryPid": "1277"
    }, {
      "categoryId": "1291",
      "categoryName": "生活缴费",
      "categoryPid": "1277"
    }]
  }, {
    "categoryId": "1292",
    "categoryName": "出行服务",
    "categoryPid": "1270",
    "children": [{
      "categoryId": "1293",
      "categoryName": "交通出行",
      "categoryPid": "1292"
    }, {
      "categoryId": "1294",
      "categoryName": "酒店预定",
      "categoryPid": "1292"
    }, {
      "categoryId": "1295",
      "categoryName": "旅游度假/商旅服务",
      "categoryPid": "1292"
    }]
  }, {
    "categoryId": "1296",
    "categoryName": "培训教育",
    "categoryPid": "1270",
    "children": [{
      "categoryId": "1297",
      "categoryName": "教育培训",
      "categoryPid": "1296"
    }, {
      "categoryId": "1298",
      "categoryName": "技能培训",
      "categoryPid": "1296"
    }, {
      "categoryId": "1299",
      "categoryName": "生活兴趣",
      "categoryPid": "1296"
    }]
  }, {
    "categoryId": "1300",
    "categoryName": "商业服务",
    "categoryPid": "1270",
    "children": [{
      "categoryId": "1301",
      "categoryName": "招聘服务",
      "categoryPid": "1300"
    }, {
      "categoryId": "1302",
      "categoryName": "商务服务",
      "categoryPid": "1300"
    }, {
      "categoryId": "1303",
      "categoryName": "保险服务",
      "categoryPid": "1300"
    }]
  }]
}, {
  "categoryId": "1304",
  "categoryName": "自营新业务",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1305",
    "categoryName": "闪电购",
    "categoryPid": "1304",
    "children": [{
      "categoryId": "1306",
      "categoryName": "闪电购",
      "categoryPid": "1305"
    }]
  }]
}, {
  "categoryId": "1321",
  "categoryName": "二手",
  "categoryPid": "0",
  "children": [{
    "categoryId": "1323",
    "categoryName": "奢侈品",
    "categoryPid": "1321",
    "children": [{
      "categoryId": "1326",
      "categoryName": "奢品钟表",
      "categoryPid": "1323"
    }, {
      "categoryId": "1327",
      "categoryName": "奢品箱包",
      "categoryPid": "1323"
    }, {
      "categoryId": "1328",
      "categoryName": "奢品服饰",
      "categoryPid": "1323"
    }, {
      "categoryId": "1329",
      "categoryName": "奢品鞋靴",
      "categoryPid": "1323"
    }, {
      "categoryId": "1330",
      "categoryName": "奢品珠宝首饰",
      "categoryPid": "1323"
    }]
  }]
}]
export default category